const state = {
  usuario: undefined
}

export default state
